import React, { useState, useEffect } from "react";
import { ToggleButton } from "primereact/togglebutton";
import { GoLightBulb } from "react-icons/go";

export const AIButton = ({
  aiMode,
  handleSetAIButton,
}: {
  aiMode: boolean;
  handleSetAIButton: (mode: boolean) => void;
}) => {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    // console.log("AI mode", aiMode);
    setIsChecked(aiMode);
  }, [aiMode]);

  useEffect(() => {
    handleSetAIButton(isChecked);
  }, [isChecked]);

  const handleActivateAIButton = () => {
    setIsChecked((prev) => !prev);
  };

  return (
    <div
      id="ai-menu-btn"
      className="card flex justify-content-center"
      style={{
        marginTop: "0rem",
        marginRight: "0.3rem",
        alignContent: "center",
        alignItems: "center",
        alignSelf: "center",
      }}
    >
      <ToggleButton
        onLabel=""
        offLabel=""
        onIcon={
          <i
            className="pi pi-microchip-ai"
            style={{
              fontSize: "1.6em",
              color: "white",
              alignSelf: "center",
              textAlign: "center",
              marginLeft: "0.5rem",
            }}
          />
        }
        offIcon={
          <i
            className="pi pi-microchip-ai"
            style={{
              fontSize: "1.6em",
              color: "lightgray",
              alignSelf: "center",
              textAlign: "center",
              marginLeft: "0.5rem",
              marginRight: "0.5rem",
            }}
          />
        }
        checked={isChecked}
        onChange={handleActivateAIButton}
        className="w-9rem"
        tooltipOptions={{ position: "bottom" }}
        tooltip="AI Mode"
      />
    </div>
  );
};
